import React, { useState } from "react";
import { Button, Typography, Box } from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Toast from "./toast";

const FileUploader = ({ allowedExtensions, onHandleUpload, uploadStatus,title }) => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [toast, setToast] = useState({ open: false, message: "" });

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    const fileExt = selectedFile.name
      .slice(selectedFile.name.lastIndexOf("."))
      .toLowerCase();

    if (!allowedExtensions.includes(fileExt)) {
      setToast(() => ({
        open: true,
        message: `Formato no permitido. Solo se aceptan ${allowedExtensions.join(
          ","
        )}`,
      }));
      event.target.value = ""; // limpiar el input
      return;
    }

    setFile(selectedFile);
    setFileName(selectedFile.name);
  };

  const handleUpload = async () => {
    if (!file) {
      setToast(() => ({
        open: true,
        message: "Por favor selecciona un archivo válido primero",
      }));
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    onHandleUpload(formData);
  };

  return (
    <>
      <Toast
        open={toast.open}
        message={toast.message}
        onClose={() => setToast({ open: false, message: "" })}
      />
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        {/* Mostrar nombre del archivo */}
        {fileName && (
          <Typography variant="body2" color="textSecondary">
            Archivo seleccionado: <strong>{fileName}</strong>
          </Typography>
        )}
        {/* Input para seleccionar archivo */}
        <input
          accept=".xlsx,.xls,.csv" // <-- solo estos formatos
          style={{ display: "none" }}
          id="upload-file"
          type="file"
          onChange={handleFileChange}
        />
        <label htmlFor="upload-file">
          <Button
            variant="outlined"
            color="secondary"
            component="span"
            startIcon={<CloudUploadIcon />}
            disabled={uploadStatus}
            style={{ textTransform: "none" }}
          >
            Seleccionar archivo
          </Button>
        </label>

        {/* Botón para subir */}
        <Button
          variant="contained"
          color="primary"
          onClick={handleUpload}
          disabled={!file || uploadStatus}
          style={{ textTransform: "none", marginTop: 12 }}
        >
         {title}
        </Button>
      </div>
    </>
  );
};

export default FileUploader;
